// extracted by mini-css-extract-plugin
export default {"noDataMessageContainer":"NoDataPage_noDataMessageContainer__vQqJH","message":"NoDataPage_message__YKE6q","description":"NoDataPage_description__I-XaL"};